export const QuestionTypes = {
  INCREASE_QUESTION_NO: 'INCREASE_QUESTION_NO',
  ADD_SCORE: 'ADD_SCORE',
  SHOW_MODEL: 'SHOW_MODEL',
  SET_SCORE: 'SET_SCORE',
  SET_QUESTION_NO: 'SET_QUESTION_NO',
  DISPLAY_QUESTION_COMPONENT: 'DISPLAY_QUESTION_COMPONENT',
  IS_CLICKED: 'IS_CLICKED'
};
